module.exports = __webpack_public_path__ + "mobile/img/huiVisitors-img1.5c3edfd5.png";